export default __webpack_public_path__ + "static/media/water_unselected.47937e52.svg";